const translations = {
    // Hero Section
    "unlock_cosmic": "శ్రీ ఆస్ట్రో వేద",
    "personalized_predictions": "రాశిచక్రం నుండి జీవిత సమాధానాల కోసం",
    "hero_description": "పురాతన జ్ఞానం మీ ఆధునిక జీవితంతో కలిసే చోట — జన్మ చార్టులు, అంకజ్యోతిష్యం, మీ ప్రేమ జీవితం, మరియు దశా ఫల రీడింగ్‌లను అన్వేషించండి, అన్నీ ప్రమాణిత జ్యోతిష్య నిపుణులచే రూపొందించబడ్డవి, మీ మార్గాన్ని స్పష్టత మరియు ఉద్దేశ్యంతో మార్గనిర్దేశం చేసుకోండి.",
    "get_my_report": "పూర్తి నివేదిక పొందండి",
    "view_sample": "నమూనా నివేదిక చూడండి",

    // Features
    "detailed_reports": "2026 వ్యక్తిగత జీవిత నివేదిక",
    "horoscope_matching": "కుండలి మ్యాచింగ్",
    "astrology_systems": "జన్మ చార్ట్, అంకజ్యోతిష్యం, దశా & మరిన్ని",

    // Modal
    "200_pages": "200+ అంతర్దృష్టిపూర్వక పేజీలు",
    "20_years_predictions": "20 సంవత్సరాల భవిష్య భవిష్యవాణులు",
    "personalized_kundli": "మీ వ్యక్తిగత వైదిక జీవిత నివేదిక",
    "most_detailed_india": "సంపూర్ణ & సమగ్ర మార్గదర్శకత్వం",
    "cosmic_blueprint_description": "మీ జీవిత ప్రయాణం దీని ద్వారా డీకోడ్ చేయబడింది:",

    "predictions_doshas_remedies": "జన్మ చార్ట్, దశలు, నక్షత్రాలు, అంకజ్యోతిష్యం, లాల్ కితాబ్, మీ ప్రేమ జీవితం, వృత్తి, ఆరోగ్య సూచిక, సాడేసతి, పరిహారాలు & మరిన్నింటిపై వివరణాత్మక అంతర్దృష్టులు.",
    "customized_for_you": "శ్రీఆస్ట్రోవేదచే మీ కోసం ప్రత్యేకంగా రూపొందించబడిన దైవిక నివేదిక",
    "check_sample_kundli": "నివేదిక అన్వేషించండి",

    // Section Title & Description
    "authentic_vedic_astrology": "శ్రీఆస్ట్రోవేద జ్యోతిష్య సేవలు",
    "cosmic_destiny": "మీ భవిష్యత్తు రహస్యాలు &",
    "through_ancient_wisdom": " వైదిక జ్యోతిష్య జ్ఞానంతో వెలుగులోకి వచ్చి, మీ జీవితానికి మార్గం చూపుతాయి",
    "two_section_description": "శ్రీఆస్ట్రోవేద జ్యోతిష్య శాస్త్రం ద్వారా సమాచారంతో కూడిన జీవిత ఎంపికలు చేయడంలో మీకు సహాయపడుతుంది — వివరణాత్మక కుండలి విశ్లేషణ, అంకజ్యోతిష్యం, దశా కాలక్రమాలు, మీ ప్రేమ జీవితం, మరియు శక్తివంతమైన లాల్ కితాబ్ పరిహారాలను కలుపుతుంది. స్పష్టత మరియు నమ్మకంతో మీ మార్గాన్ని కనుగొనండి.",

    // Features – focused on user benefits
    "personalized_birth_charts": "మీ నిజమైన స్వయాన్ని అర్థం చేసుకోండి",
    "personalized_birth_charts_desc": "దాగిన బలాలు, బలహీనతలు మరియు జీవిత పద్ధతులను వెలికితీసేందుకు మీ జన్మ చార్ట్, లగ్నం మరియు గ్రహ స్థానాల పూర్తి విశ్లేషణ పొందండి.",

    "remedial_gemstone_guidance": "మీ జీవిత అడ్డంకులను అధిగమించండి",
    "remedial_gemstone_guidance_desc": "గ్రహ అసమతుల్యతలను తటస్థీకరించడానికి మరియు సానుకూల ఫలితాలను ఆకర్షించడానికి ప్రభావవంతమైన పరిహారాలు, రత్న సూచనలు మరియు సాడేసతి విశ్లేషణ పొందండి.",

    "marriage_compatibility_analysis": "మీ జాతకంలో లిఖించబడిన అనుకూల సంబంధాలను తెలుసుకొండి",
    "marriage_compatibility_analysis_desc": "సంబంధ డైనమిక్స్‌ను అర్థం చేసుకోవడానికి మరియు దీర్ఘకాలిక అనుకూలతను నిర్ధారించడానికి మా అధునాతన ప్రేమ మరియు వివాహ అనుకూలత సాధనాలను ఉపయోగించండి.",

    "career_life_predictions": "జ్యోతిష్య జ్ఞానంతో సురక్షిత మీ భవిష్యత్తును రూపుదిద్దుకోండి",
    "career_life_predictions_desc": "వృత్తి, ఆరోగ్యం, ఆర్థికాలు మరియు వార్షిక ధోరణుల గురించి ఖచ్చితమైన భవిష్యవాణులు పొందండి, తద్వారా మీరు ముందుగా ప్లాన్ చేసుకోవచ్చు మరియు శక్తివంతమైన నిర్ణయాలు తీసుకోవచ్చు.",

    // CTA & Trust
    "start_your_journey": "మీ రాశిచక్ర మార్గాన్ని అన్‌లాక్ చేయండి",
    "learn_more": "పూర్తి సేవలను అన్వేషించండి",
    "rated_by_clients": "10,000+ క్లయింట్లచే 4.9/5 రేట్ చేయబడింది",
    "confidential_secure": "100% గోప్యత & సురక్షితం",

    "authentic_astrology_banner": "ప్రామాణిక జ్యోతిష్య సేవలు",

    "match_kundli": "కుండలి మ్యాచింగ్",
    "match_kundli_desc": "మీరు మరియు మీ జీవిత భాగస్వామి కోసం వివాహ అనుకూలత, జాతక మ్యాచింగ్ పరిశీలించండి.",
    "match_now": "ఇప్పుడే మ్యాచ్ చేయండి",

    "your_life_predictions": "మీ జీవిత భవిష్యవాణులు",
    "life_predictions_desc": "మీ జన్మ జాతకం ద్వారా మీ భవిష్యత్తు రహస్యాలను తెలుసుకోండి.",
    "view_predictions": "భవిష్యవాణులను చూడండి",

    "ask_question_price": "ఒక ప్రశ్న అడగండి",
    "ask_question_desc": "ఏదైనా వ్యక్తిగత లేదా అత్యవసర ప్రశ్నకు నిపుణుల సమాధానాలు పొందండి.",
    "ask_now": "ఇప్పుడే అడగండి",

    "career_guidance": "వృత్తి",
    "career_desc": "మీ నక్షత్రాల ఆధారంగా సరైన వృత్తి మార్గం మరియు ఉద్యోగ అవకాశాలను తెలుసుకోండి.",
    "explore_career": "వృత్తిని అన్వేషించండి",

    "love_compatibility": "ప్రేమ",
    "love_desc": "మీ రాశి ప్రకారం సరైన వృత్తి మరియు అవకాశాలు తెలుసుకోండి.",
    "check_love_life": "ప్రేమ జీవితాన్ని తనిఖీ చేయండి",

    "2026_personalized_report": "2026 వ్యక్తిగత నివేదిక",
    "2026_report_desc": "మీ ప్రేమ జీవితం, సంబంధ అనుకూలత, భవిష్య ప్రణయ రహస్యాలను జ్యోతిష్యం ద్వారా తెలుసుకోండి.",
    "get_2026_report": "2026 నివేదిక పొందండి",

    "dasha_phal_analysis": "దశా ఫల విశ్లేషణ",
    "dasha_analysis_desc": "మీ జన్మ వివరాల ఆధారంగా మీకు అనుకూలమైన సమగ్ర వార్షిక జ్యోతిష్య ఫలితాలు.",
    "analyze_now": "ఇప్పుడే విశ్లేషించండి",

    "sade_sati_report": "సాడేసతి జీవిత నివేదిక",
    "sade_sati_desc": "శని యొక్క సాడేసతి మిమ్మల్ని ఎలా ప్రభావితం చేస్తుందో తెలుసుకోండి మరియు పరిహారాలు పొందండి.",
    "check_sade_sati": "సాడేసతి తనిఖీ చేయండి",

    // Horoscope section
    "free_daily_horoscope": "ప్రతి రాశి, ప్రతి రహస్యం – నక్షత్రాలు మీ గురించి ఏమి చెబుతున్నాయో కనుగొనండి",
    "horoscope_categories": "",

    // Zodiac signs
    "aries": "మేషం",
    "taurus": "వృషభం", 
    "gemini": "మిథునం",
    "cancer": "కర్కాటకం",
    "leo": "సింహం",
    "virgo": "కన్య",
    "libra": "తుల",
    "scorpio": "వృశ్చికం",
    "sagittarius": "ధనుస్సు",
    "capricorn": "మకరం",
    "aquarius": "కుంభం",
    "pisces": "మీనం",

    // Date ranges
    "aries_dates": "మార్చి 21 - ఏప్రిల్ 19",
    "taurus_dates": "ఏప్రిల్ 20 - మే 20",
    "gemini_dates": "మే 21 - జూన్ 20",
    "cancer_dates": "జూన్ 21 - జులై 22",
    "leo_dates": "జులై 23 - ఆగస్ట్ 22",
    "virgo_dates": "ఆగస్ట్ 23 - సెప్టెంబర్ 22",
    "libra_dates": "సెప్టెంబర్ 23 - అక్టోబర్ 22",
    "scorpio_dates": "అక్టోబర్ 23 - నవంబర్ 21",
    "sagittarius_dates": "నవంబర్ 22 - డిసెంబర్ 21",
    "capricorn_dates": "డిసెంబర్ 22 - జనవరి 19",
    "aquarius_dates": "జనవరి 20 - ఫిబ్రవరి 18",
    "pisces_dates": "ఫిబ్రవరి 19 - మార్చి 20",

    // Modal content keys
    "today_horoscope": "నేటి రాశిఫలం",
    "basic_info": "ప్రాథమిక సమాచారం",
    "characteristics": "లక్షణాలు",
    "lucky_elements": "అదృష్ట అంశాలు",
    "lucky_color": "అదృష్ట రంగు",
    "lucky_number": "అదృష్ట సంఖ్య", 
    "element": "మూలకం",
    "ruling_planet": "పాలక గ్రహం",
    "get_detailed_reading": "వివరణాత్మక రీడింగ్ పొందండి",
    "more_insights": "మరిన్ని అంతర్దృష్టులు",
    "likes": "ఇష్టాలు",
    "dislikes": "అయిష్టాలు",
    "food": "ఆహారం",
    "travel_style": "ప్రయాణ శైలి",
    "movie_match": "చలనచిత్ర మ్యాచ్",
    "song_vibe": "పాట వైబ్",
    "celebs": "ప్రముఖులు",

    // Aries content
    "aries_horoscope": "నేడు అగ్నిమయ శక్తి మరియు కొత్త అవకాశాలను తెస్తుంది. మీ నాయకత్వ నైపుణ్యాలు మెరుస్తాయి, కొత్త ప్రాజెక్టులను ప్రారంభించడానికి లేదా పరిస్థితులపై నియంత్రణ తీసుకోవడానికి ఇది ఖచ్చితమైన రోజు.",
    "aries_traits": "నిర్భయం, పోటీతత్వం, శక్తి మరియు చొరవతో నిండినది. ఎల్లప్పుడూ చర్య తీసుకోవడంలో మొదటివారు.",
    "aries_likes": "గెలుపు, నాయకత్వం, ఉత్సాహం, సవాళ్లు.",
    "aries_dislikes": "సోమరితనం, ఆలస్యాలు, అనిర్ణయత.",
    "aries_food": "కారపు ఆహారం, గ్రిల్డ్ మాంసం, ప్రోటీన్ సమృద్ధ భోజనం.",
    "aries_travel_style": "సాహస క్రీడలు, ఒంటరి ట్రెక్కింగ్, రోడ్ ట్రిప్స్.",
    "aries_movie_match": "మ్యాడ్ మాక్స్: ఫ్యూరీ రోడ్",
    "aries_song_vibe": "ఐ ఆఫ్ ది టైగర్",
    "aries_celebs": "లేడీ గాగా, అజయ్ దేవగణ్, రాబర్ట్ డౌనీ జూనియర్.",
    "aries_color": "ఎరుపు",
    "aries_number": "9",
    "aries_element": "అగ్ని",
    "aries_planet": "మంగళ్",

    "taurus_horoscope": "వినోదం మరియు సౌకర్యం కోసం ఒక రోజు. స్థిరత్వంపై దృష్టి పెట్టండి మరియు జీవితంలోని మంచి విషయాలను ఆనందించండి. మీ సహనం శాశ్వత ఫలితాలతో రివార్డ్ చేయబడుతుంది.",
"taurus_traits": "ప్రశాంతత, నమ్మకత్వం, ఇంద్రియప్రియత, విశ్వసనీయత. సౌకర్యం మరియు లగ్జరీని ప్రేమిస్తుంది.",
"taurus_likes": "ప్రకృతి, సంగీతం, మంచి ఆహారం, చక్కని వస్తువులు.",
"taurus_dislikes": "అకస్మాత్తుగా మార్పు, త్వరపెట్టడం, అస్థిరత.",
"taurus_food": "గొప్పగా చేసిన భోజనం, డెజర్ట్లు, గూర్మెట్ చీజ్, చాక్లెట్లు.",
"taurus_travel_style": "ప్రకృతి రిట్రీట్లు, వైన్యార్డ్లు, లగ్జరీ రిసార్ట్లు.",
"taurus_movie_match": "ది హండ్రెడ్-ఫుట్ జర్నీ",
"taurus_song_vibe": "ఆల్ ఆఫ్ మి",
"taurus_celebs": "గిగి హదీద్, వరుణ్ దవన్, అడెలె",
"taurus_color": "ఆకుపచ్చ & పింక్",
"taurus_number": "6",
"taurus_element": "భూమి",
"taurus_planet": "శుక్రుడు",

"gemini_horoscope": "ఈరోజు సంభాషణ కీలకం. మీ చమత్కారం మరియు అనుకూలత కొత్త తలుపులను తెరుస్తాయి. నెట్‌వర్కింగ్ మరియు ఆలోచనలను పంచుకోవడానికి ఖచ్చితమైన సమయం.",
"gemini_traits": "సామాజిక, చమత్కారమైన, అనుకూలమైన, వేగవంతమైన ఆలోచనాపరులు, బహువిధ పనిచేసేవారు.",
"gemini_likes": "మాట్లాడడం, రాయడం, టెక్, కొత్త అనుభవాలు.",
"gemini_dislikes": "పునరావృతం, విసుగు, నిశ్శబ్దం.",
"gemini_food": "ఫింగర్ ఫుడ్, వీధి స్నాక్స్, విచిత్రమైన వంటకాలు.",
"gemini_travel_style": "చిన్న ఆకస్మిక ట్రిప్స్, నగర అన్వేషణ.",
"gemini_movie_match": "ది సోషల్ నెట్‌వర్క్",
"gemini_song_vibe": "లెవిటేటింగ్",
"gemini_celebs": "ఏంజెలినా జోలీ, కరణ్ జోహర్, కాన్యే వెస్ట్",
"gemini_color": "పసుపు",
"gemini_number": "5",
"gemini_element": "గాలి",
"gemini_planet": "బుధుడు",

"cancer_horoscope": "నేడు మీ అంతర్దృష్టిని నమ్మండి. కుటుంబం మరియు గృహ విషయాలకు ప్రాధాన్యత ఇవ్వండి. మీ పోషకత్వ స్వభావం చుట్టూ ఉన్నవారికి ఓదార్పు తెస్తుంది.",
"cancer_traits": "లోతైన భావోద్వేగం, పోషకత్వం, అంతర్దృష్టి, కుటుంబోన్ముఖత.",
"cancer_likes": "ఇల్లు, ఓదార్పు ఆహారం, జ్ఞాపకాలు, దగ్గరి స్నేహితులు.",
"cancer_dislikes": "కఠినత్వం, వదిలివేయడం, మార్పు.",
"cancer_food": "ఇంటి భోజనం, అన్నం వంటకాలు, డెజర్ట్లు.",
"cancer_travel_style": "బీచ్ హౌస్‌లు, పూర్వీకుల స్థలాలు, ఆధ్యాత్మిక రిట్రీట్లు.",
"cancer_movie_match": "ది నోట్‌బుక్",
"cancer_song_vibe": "ఫోటోగ్రాఫ్",
"cancer_celebs": "సెలీనా గోమెజ్, ప్రియాంక చోప్రా, టామ్ హ్యాంక్స్",
"cancer_color": "తెలుపు & వెండి",
"cancer_number": "2",
"cancer_element": "నీరు",
"cancer_planet": "చంద్రుడు",

"leo_horoscope": "నేడు మీ సహజ ఆకర్షణ ప్రకాశవంతంగా మెరుస్తుంది. కేంద్ర వేదికను తీసుకోండి మరియు మీ సృజనాత్మకతను ప్రవహింపచేయండి. గుర్తింపు మరియు ప్రశంసలు మీ వైపుకు వస్తున్నాయి.",
"leo_traits": "ధైర్యవంతుడు, నాటకీయుడు, హృదయవంతుడు, జన్మజాత నాయకుడు. దృష్టిని కోరుకుంటాడు.",
"leo_likes": "గ్లామర్, వేదిక, వేడుకలు, నాయకత్వం.",
"leo_dislikes": "విస్మరించబడడం, నిస్తేజత, విమర్శ.",
"leo_food": "గ్రిల్డ్ ఆహారాలు, గొప్ప డెజర్ట్లు, విదేశీ వంటకాలు.",
"leo_travel_style": "లగ్జరీ క్రూసెస్, సాంస్కృతిక పరేడ్‌లు, స్పాట్‌లైట్ గమ్యస్థానాలు.",
"leo_movie_match": "ది గ్రేట్ గ్యాట్స్‌బీ",
"leo_song_vibe": "అప్‌టౌన్ ఫంక్",
"leo_celebs": "జెన్నిఫర్ లోపెజ్, సైఫ్ అలీ ఖాన్, బరాక్ ఒబామా",
"leo_color": "బంగారం & నారింజ",
"leo_number": "1",
"leo_element": "అగ్ని",
"leo_planet": "సూర్యుడు",

"virgo_horoscope": "నేడు వివరాలపై దృష్టి ఫలిస్తుంది. మీర్ విశ్లేషణాత్మక నైపుణ్యాలు క్లిష్టమైన సమస్యలను పరిష్కరించడంలో సహాయపడతాయి. ఉత్తమ ఫలితాల కోసం ఆరోగ్యం మరియు వ్యవస్థీకరణపై దృష్టి పెట్టండి.",
"virgo_traits": "పరిపూర్ణతావాది, ఆచరణాత్మకత, తెలివైనది, ఆరోగ్య-చేతన.",
"virgo_likes": "స్వచ్ఛత, ప్రణాళికలు, సహాయం, నేర్చుకోవడం.",
"virgo_dislikes": "అశాంతి, అసమర్థత, భావోద్వేగ విస్ఫోటనలు.",
"virgo_food": "ఆరోగ్యకరమైన బౌల్స్, క్లీన్ ఈటింగ్, సూప్స్, సలాడ్లు.",
"virgo_travel_style": "వెల్‌నెస్ రిసార్ట్లు, ఎకో స్టేస్, వారసత్వ ప్రాంతాలు.",
"virgo_movie_match": "ది ఇమిటేషన్ గేమ్",
"virgo_song_vibe": "లవ్లీ",
"virgo_celebs": "కీనూ రీవ్స్, కరీనా కపూర్, జెండాయా",
"virgo_color": "తెలుపు & భూమి టోన్లు",
"virgo_number": "6",
"virgo_element": "భూమి",
"virgo_planet": "బుధుడు",

"libra_horoscope": "సామరస్యం మరియు సమతుల్యత మీ దినాన్ని మార్గనిర్దేశం చేస్తాయి. న్యాయం మరియు అందంపై దృష్టి పెట్టినప్పుడు సంబంధాలు వికసిస్తాయి. కళాత్మక కార్యకలాపాలు ఆనందం తెస్తాయి.",
"libra_traits": "దయగలది, న్యాయమైనది, రొమాంటిక్, శాంతిప్రియుడు, సౌందర్యప్రేమి.",
"libra_likes": "కళ, ఫ్యాషన్, రొమాన్స్, సంభాషణ.",
"libra_dislikes": "అసభ్యత, వాదనలు, అసమతుల్యత.",
"libra_food": "పేస్ట్రీలు, వైన్, చీజ్, తేలికపాటి పాస్తాలు.",
"libra_travel_style": "పారిస్, వెనిస్, రొమాంటిక్ లేదా ఫ్యాషన్ గమ్యస్థానాలు.",
"libra_movie_match": "లా లా ల్యాండ్",
"libra_song_vibe": "జస్ట్ ది వే యు ఆర్",
"libra_celebs": "కిమ్ కర్దాషియాన్, రణ్‌బీర్ కపూర్, హ్యూ జాక్‌మ్యాన్",
"libra_color": "ఆకాశ నీలం & గులాబీ పింక్",
"libra_number": "7",
"libra_element": "గాలి",
"libra_planet": "శుక్రుడు",

"scorpio_horoscope": "లోతైన రూపాంతరం గాలిలో ఉంది. మీ సహజ ప్రేరణలను నమ్మండి మరియు మార్పును స్వీకరించండి. మీ తీవ్రత మరియు అభిరుచి పురోగతి క్షణాలకు దారితీస్తాయి.",
"scorpio_traits": "రహస్యమైనది, తీవ్రమైనది, నమ్మకస్తుడు, భావోద్వేగంలో లోతైనది.",
"scorpio_likes": "రహస్యాలు, రూపాంతరం, అభిరుచి.",
"scorpio_dislikes": "అనేస్టిటీ, లోతులేని వ్యక్తులు, ద్రోహం.",
"scorpio_food": "కారమైనది, బోల్డ్ రుచులు, డార్క్ చాక్లెట్, మిస్టరీ భోజనం.",
"scorpio_travel_style": "దాచిన రత్నాలు, గుహలు, రహస్య బీచ్‌లు.",
"scorpio_movie_match": "గాన్ గర్ల్",
"scorpio_song_vibe": "టేక్ మి టు చర్చ్",
"scorpio_celebs": "రయాన్ గోస్లింగ్, షారుఖ్ ఖాన్, కేటీ పెర్రీ",
"scorpio_color": "నలుపు & లోతైన ఎరుపు",
"scorpio_number": "8",
"scorpio_element": "నీరు",
"scorpio_planet": "మంగళ్ & ప్లూటో",

"sagittarius_horoscope": "సాహసం ఈరోజు మీ పేరును పిలుస్తుంది. నేర్చుకోవడం లేదా ప్రయాణం ద్వارా మీ హరిజాన్లను విస్తరించండి. మీ ఆశావాదం ఇతరులను పెద్దగా కలలుకనేందుకు ప్రేరేపిస్తుంది.",
"sagittarius_traits": "స్వేచ్ఛాప్రేమి, హాస్యభరితుడు, తత్వాచింతనకుడు, ఆశావాది.",
"sagittarius_likes": "ప్రయాణం, సాహసం, సత్యం, లోతైన సంభాషణలు.",
"sagittarius_dislikes": "నియమాలు, అంటుకుని ఉండటం, రొటీన్.",
"sagittarius_food": "వీధి ఆహారం, BBQ, అంతర్జాతీయ వంటకాలు.",
"sagittarius_travel_style": "బ్యాక్‌ప్యాకింగ్, అసాధారణ సాహసాలు, ఒంటరి ట్రిప్స్.",
"sagittarius_movie_match": "ఇంటు ది వైల్డ్",
"sagittarius_song_vibe": "అడ్వెంచర్ ఆఫ్ ఎ లైఫ్‌టైమ్",
"sagittarius_celebs": "టేలర్ స్విఫ్ట్, ధర్మేంద్ర, బ్రాడ్ పిట్",
"sagittarius_color": "ముక్య & టర్కాయిస్",
"sagittarius_number": "9",
"sagittarius_element": "అగ్ని",
"sagittarius_planet": "గురువు",

"capricorn_horoscope": "నేడు కఠిన పని మరియు క్రమశిక్షణ విజయాన్ని తెస్తాయి. మీ పద్ధతిగత దృష్టికోణం దీర్ఘకాలిక సాధనలకు తలుపులను తెరుస్తుంది. మీ లక్ష్యాలపై దృష్టి సారించండి.",
"capricorn_traits": "ప్రతిష్ఠాకాంక్షీ, పరిపక్వత, క్రమశిక్షణ, కాలాతీతత.",
"capricorn_likes": "విజయం, నిర్మాణం, విశ్వసనీయత, సంప్రదాయాలు.",
"capricorn_dislikes": "సోమరితనం, అనేస్టితీ, షార్ట్‌కట్స్.",
"capricorn_food": "సాంప్రదాయ భోజనం, సూప్స్, రోట్లు, నెమ్మదిగా వండిన ఆహారం.",
"capricorn_travel_style": "కొండలు, చారిత్రిక నగరాలు, వ్యాపార-వినోద ట్రిప్స్.",
"capricorn_movie_match": "ది పర్స్యూట్ ఆఫ్ హ్యాపీనెస్",
"capricorn_song_vibe": "హాల్ ఆఫ్ ఫేమ్",
"capricorn_celebs": "దీపిక పదుకొణె, హృతిక్ రోషన్, మిషెల్ ఒబామా",
"capricorn_color": "నేవీ & గోధుమ రంగు",
"capricorn_number": "10",
"capricorn_element": "భూమి",
"capricorn_planet": "శనియుడు",

"aquarius_horoscope": "ఆవిష్కరణ మరియు మానవతావాద ప్రయత్నాలు కేంద్ర వేదికను తీసుకుంటాయి. మీ అనన్య దృక్పథం పాత సమస్యలకు తాజా పరిష్కారాలను తెస్తుంది. పెట్టె బయట ఆలోచించండి.",
"aquarius_traits": "దూరదృష్టి, స్వతంత్రత, అసాధారణత, మానవతావాది.",
"aquarius_likes": "ఆవిష్కరణ, సామాజిక కారణాలు, ఆలోచనలు, సమాజం.",
"aquarius_dislikes": "పరిమితులు, మూస పద్ధతులు, రొటీన్.",
"aquarius_food": "వేగన్/మొక్కజొన్న ఆధారిత, ఫ్యూజన్ ఫుడ్, స్మూతీలు.",
"aquarius_travel_style": "భవిష్యత్ నగరాలు, వాలంటీర్ టూరిజం, కారణంతో రోడ్ ట్రిప్స్.",
"aquarius_movie_match": "ది మ్యాట్రిక్స్",
"aquarius_song_vibe": "రేడియోయాక్టివ్",
"aquarius_celebs": "ఓప్రా విన్‌ఫ్రే, ప్రీతి జింటా, హ్యారీ స్టైల్స్",
"aquarius_color": "ఎలక్ట్రిక్ బ్లూ & అక్వా",
"aquarius_number": "11",
"aquarius_element": "గాలి",
"aquarius_planet": "యూరేనస్ & శని",

"pisces_horoscope": "నేడు మీ కల్పనను ప్రవహింపచేయండి. కలలు మరియు అంతర్దృష్టి మిమ్మల్ని అందమైన ఆవిష్కరణలకు మార్గనిర్దేశం చేస్తాయి. మీ దయగల స్వభావం అనేక హృదయాలను తాకుతుంది.",
"pisces_traits": "సహానుభూతిగలది, కలలుగన్నది, కళాత్మకత, అంతర్దృష్టి.",
"pisces_likes": "కళ, ప్రేమ కథలు, సంగీతం, కలలు.",
"pisces_dislikes": "కఠిన వాస్తవాలు, బిగ్గరగా జనసమూహాలు, సంఘర్షణ.",
"pisces_food": "సముద్రపు ఆహారం, పాస్తా, ఓదార్పు ఆహారం, ఐస్ క్రీమ్.",
"pisces_travel_style": "ద్వీపాలు, రిట్రీట్లు, నదీ తీర వసెట్స్.",
"pisces_movie_match": "లైఫ్ ఆఫ్ పై",
"pisces_song_vibe": "సమ్‌వన్ లైక్ యు",
"pisces_celebs": "రిహానా, ఆలియా భట్ట్, జస్టిన్ బీబర్",
"pisces_color": "లావెండర్ & సముద్రపు ఆకుపచ్చ",
"pisces_number": "12",
"pisces_element": "నీరు",
"pisces_planet": "నెప్ట్యూన్ & గురువు",

"review_title": "Client Testimonials",

"why_choose": "శ్రీఆస్ట్రోవేదను ఎందుకు ఎంచుకోవాలి",

"unlimited_kundlis_question": "నేను బహుళ కుండలీలను అభ్యర్థించగలనా?",
"unlimited_kundlis_answer": "అవును! ప్రతి అభ్యర్థనను శ్రద్ధగా పరిశీలించి, వ్యక్తిగత PDF నివేదిక రూపంలో అందిస్తాము. మీ జీవితం మార్చే మార్గసూచనలు – ఇప్పుడు మీకు అందుబాటులో.",

"kundli_reports_question": "కుండలీ నివేదికలలో ఏమి ఉంటుంది?",
"kundli_reports_answer": "ప్రతి నివేదిక వృత్తిపరంగా తయారుచేసిన PDF లో జన్మ చార్ట్, లగ్న విశ్లేషణ, దశ, గోచర, నక్షత్ర, అంకజ్యోతిష్యం, ప్రేమ & వృత్తి మార్గదర్శకత్వం, ఆరోగ్య సూచిక, లాల్ కితాబ్ పరిహారాలు మరియు మరిన్నింటిని కలిగి ఉంటుంది.",

"saving_notes_question": "నేను సెషన్ నోట్స్ లేదా పరిహారాలు జోడించగలనా?",
"saving_notes_answer": "ఖచ్చితంగా. మీరు నిర్దిష్ట పరిహారాలు, ఫాలో-అప్ నోట్స్ లేదా అదనపు పరిశీలనలను చేర్చాలని అనుకుంటే, మీ అభ్యర్థన సమయంలో వాటిని పేర్కొనండి.",

"devices_question": "నేను నివేదికను ఎలా స్వీకరిస్తాను?",
"devices_answer": "మీరు **24 గంటలలో** PDF ఫార్మాట్‌లో **WhatsApp, ఇమెయిల్ లేదా SMS** ద్వారా నివేదికను స్వీకరిస్తారు—మీరు ఇష్టపడే పద్ధతిని అనుసరించి.",

"data_safety_question": "నా వ్యక్తిగత డేటా సురక్షితమేనా?",
"data_safety_answer": "అవును. అన్ని వినియోగదారు డేటా పూర్తిగా గోప్యంగా ఉంచబడుతుంది మరియు ఎప్పటికీ భాగస్వామ్యం చేయబడదు. మీ గోప్యత మరియు నమ్మకం మా అత్యధిక ప్రాధాన్యతలు.",

"advertising_question": "నివేదిక ప్రకటనలు లేకుండా ఉందా?",
"advertising_answer": "100% ప్రకటనలు లేకుండా. మా నివేదికలు ఎలాంటి ప్రచార అంతరాయాలు లేకుండా స్వచ్ఛమైన, దృష్టి సారించిన జ్యోతిష్య అంతర్దృష్టులను అందించడానికి రూపొందించబడ్డాయి.",

"client_management_question": "నేను నా క్లయింట్లకు నివేదికలను ఆర్డర్ చేయగలనా?",
"client_management_answer": "అవును! మీరు జ్యోతిష్యుడు, కన్సల్టెంట్ లేదా వెల్‌నెస్ కోచ్ అయినా, మీరు మీ క్లయింట్లకు వ్యక్తిగత నివేదికలను ఆర్డర్ చేయవచ్చు. బల్క్ మరియు పునరావృత ఆర్డర్లకు మద్దతు ఉంది.",

"customize_charts_question": "నేను చార్ట్ స్టైల్ లేదా లేఅవుట్‌ను ఎంచుకోవచ్చా?",
"customize_charts_answer": "అవును. మేము **ఉత్తర, దక్షిణ మరియు తూర్పు భారతీయ చార్ట్ ఫార్మాట్లను** అందిస్తాము. అవసరమైతే మీరు ఫాంట్ సైజ్ లేదా రంగు ప్రాధాన్యతలను కూడా అభ్యర్థించవచ్చు.",

"discounts_question": "ఏవైనా తగ్గింపులు అందుబాటులో ఉన్నాయా?",
"discounts_answer": "అవును. మేము కాలానుగుణ తగ్గింపులు, కాంబో ఆఫర్లు మరియు జ్యోతిష్యులు, రెగ్యులర్ క్లయింట్ల కోసం ప్రత్యేక రేట్లు అందిస్తాము. తాజా ఆఫర్లు మరియు అప్‌డేట్ల కోసం WhatsApp ద్వారా అనుసంధానంలో ఉండండి.",

"affiliate_question": "నేను ఇతరులను రెఫర్ చేయడం ద్వారా సంపాదించగలనా?",
"affiliate_answer": "అవును! **శ్రీఆస్ట్రోవేద అఫిలియేట్ ప్రోగ్రామ్‌లో** చేరండి మరియు స్నేహితులు, క్లయింట్లు లేదా మీ ప్రేక్షకులను రెఫర్ చేయడం ద్వారా కమీషన్లు సంపాదించండి.",

"languages_question": "ప్రాంతీయ భాషలలో నివేదికలు అందుబాటులో ఉన్నాయా?",
"languages_answer": "అవును. మేము **హిందీ, ఇంగ్లీష్, తెలుగు, కన్నడ, తమిళ, మరాఠీ మరియు బెంగాలీ** లలో నివేదికలను అందిస్తాము మరియు అభ్యర్థనపై ఇతర ప్రాంతీయ భాషలలో కూడా అందిస్తాము.",

"delivery_time_question": "నేను నా నివేదికను ఎంత త్వరగా స్వీకరిస్తాను?",
"delivery_time_answer": "మీ వివరాలను సమర్పించిన తర్వాత **24 గంటలలో** మీరు మీ పూర్తి నివేదికను స్వీకరిస్తారు. WhatsApp, ఇమెయిల్ లేదా SMS ద్వారా డెలివరీ అందుబాటులో ఉంది.",

"services_question": "ఏ జ్యోతిష్య సేవలు చేర్చబడ్డాయి?",
"services_answer": "మా నివేదికలలో ఇవి ఉంటాయి: **జన్మ చార్ట్, కుండలీ మ్యాచింగ్, లగ్న & దశ విశ్లేషణ, గోచర, నక్షత్ర, అంకజ్యోతిష్యం, వృత్తి & ప్రేమ మార్గదర్శకత్వం, వార్షిక & దైనిక భవిష్యవాణులు, ఆరోగ్య సూచిక, లాల్ కితాబ్ పరిహారాలు, సాడేసతి నివేదికలు, దోష విశ్లేషణ, రత్న సూచనలు** మరియు మరిన్ని.",

"unmute_first_card": "మొదటి కార్డ్‌ను అన్‌మ్యూట్ చేయండి",
"mute_first_card": "మొదటి కార్డ్‌ను మ్యూట్ చేయండి"

};

export default translations;
